import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { PhoneNumberType } from 'google-libphonenumber'
import { isNil } from 'ramda'
import * as Yup from 'yup'

import { globalDefinitions } from '@/defined-translations'
import '@/yup-phone-number/lib'

const generateContactInformationFormSchema = () => {
  return Yup.object().shape(
    {
      address: Yup.object({
        streetAddress: Yup.string()
          .max(80, i18n._(globalDefinitions.maxLength, { value: 80 }))
          .matches(
            /.*\b\d+/,
            t({
              id: 'contactinfo.address-streetAddress',
              message: 'Gelieve ook een huisnummer in te voeren',
            }),
          )
          .required(
            t({
              id: 'globals.validation.required',
              message: 'Dit veld is verplicht',
            }),
          ),
        zipOrPostalCode: Yup.string()
          .max(7, i18n._(globalDefinitions.maxLength, { value: 7 }))
          .required(),
        city: Yup.string()
          .max(40, i18n._(globalDefinitions.maxLength, { value: 40 }))
          .required(),
        country: Yup.string().required(),
      }),
      email: Yup.string().required(i18n._(globalDefinitions.required)).email(i18n._(globalDefinitions.invalidEmail)),
      cellphone: Yup.string().when(['contactPhone'], {
        is: (contactPhone: string) => isNil(contactPhone),
        then: Yup.string()
          .required(
            t({
              id: 'contactinfo.cellphone-contactPhone',
              message: 'Telefoon (vast) of telefoon (mobiel) is verplicht',
            }),
          )
          .phoneNumber([PhoneNumberType.MOBILE], [], {
            type: i18n._(globalDefinitions.invalidTypeMobile),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneMobile),
          }),
        otherwise: Yup.string().when(['cellphone'], {
          is: (cellPhone: string) => !isNil(cellPhone),
          then: Yup.string().phoneNumber([PhoneNumberType.MOBILE], [], {
            type: i18n._(globalDefinitions.invalidTypeMobile),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneMobile),
          }),
          otherwise: Yup.string().notRequired(),
        }),
      }),
      contactPhone: Yup.string().when(['cellphone'], {
        is: (cellphone: string) => isNil(cellphone),
        then: Yup.string()
          .required(
            t({
              id: 'contactinfo.cellphone-contactPhone',
              message: 'Telefoon (vast) of telefoon (mobiel) is verplicht',
            }),
          )
          .phoneNumber([PhoneNumberType.FIXED_LINE], [], {
            type: i18n._(globalDefinitions.invalidTypeFixed),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneFixed),
          }),
        otherwise: Yup.string().when(['contactPhone'], {
          is: (contactPhone: string) => !isNil(contactPhone),
          then: Yup.string().phoneNumber([PhoneNumberType.FIXED_LINE], [], {
            type: i18n._(globalDefinitions.invalidTypeFixed),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneFixed),
          }),
          otherwise: Yup.string().notRequired(),
        }),
      }),
    },
    [
      ['cellphone', 'contactPhone'],
      ['cellphone', 'cellphone'],
      ['contactPhone', 'contactPhone'],
    ],
  )
}

export { generateContactInformationFormSchema }
